/**
 * M34 — the app-icon badge, the thing Andy has never seen because nothing ever called the
 * Badging API. One function owns the rule; it runs in two places that cannot share code any
 * other way:
 *
 * - the service worker's push handler, with the count the payload carries — a push landing
 *   on an offline phone cannot ask the server, so the server counts at send time;
 * - the app shell, whenever the unread count changes — which is what makes reading in the
 *   app take the badge DOWN, something a push can never do.
 *
 * Zero clears rather than setting: `setAppBadge(0)` is specified as "clear" but a literal 0
 * bubble on some launchers reads as one unread thing. Rejections are swallowed — iOS grants
 * the API only to an installed PWA with notification permission, and a badge that could not
 * be set is not an error worth surfacing anywhere.
 */
export type BadgeNavigator = {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function applyBadge(nav: BadgeNavigator, unread: number): void {
  if (unread > 0) nav.setAppBadge?.(unread).catch(() => undefined);
  else nav.clearAppBadge?.().catch(() => undefined);
}
